import React from 'react'
import EmployeeAdminLayout from '../layouts/employeeAdminLayout'
import DynamicHeadTag from '../common/DynamicHeadTag'
import FreeTrialOfferModal from '../payrollFreeTrial/FreeTrialOfferModal';
import useInlinePageRouter from "../general/useInlinePageRouter";
// import FreeTrialInlineCountdown from '../payrollFreeTrial/FreeTrialInlineCountdown';
// import useEmployerProducts from 'hooks/useEmployerProducts';
import Maybe from '../common/Maybe';
import useRouteAccess from 'hooks/useRouteAccess';
import { PayrollOnboarding } from 'pages/payroll/onboarding/PayrollOnboarding';
import { RestrictedFeature } from 'pages/misc/RestrictedFeature';

const GrossPayrollLayout = ({children}) => {
	// const {isPayrollUser} = useEmployerProducts();
	const { InlineRouterTab } = useInlinePageRouter();
	const { isPayrollOnboardingRequired, isPayrollOdpCreditRestricted } = useRouteAccess();

	return (
		<EmployeeAdminLayout>
			<Maybe condition={isPayrollOnboardingRequired}>
				<PayrollOnboarding />
			</Maybe>
			<Maybe condition={isPayrollOdpCreditRestricted}>
				<RestrictedFeature />
			</Maybe>
			<Maybe condition={!isPayrollOnboardingRequired && !isPayrollOdpCreditRestricted}>
				<FreeTrialOfferModal />
				
				<DynamicHeadTag 
					headerText="Payroll Setup"
					headerDescription="Configure your payroll settings and automate payroll processes."
				/>
				
				<div className='flex items-center'>
					<div className="page-title mr-3s">
						Payroll Configuration
					</div>
				</div>
				
				<div className="mt-6 flex items-center">
					<InlineRouterTab
						items={[
							{
								title: "Pay Schedule",
								path: "/payroll-configuration/pay-schedule",
							},
							{
								title: "Pay Structure",
								path: "/payroll-configuration/pay-structure",
							},
							{
								title: "Benefits in Kind",
								path: "/payroll-configuration/benefits",
							},
							{
								title: "Allowances & Bonus",
								path: "/payroll-configuration/allowances",
							},
							{
								title: "Remittance Parties",
								path: "/payroll-configuration/remittance-parties",
							},
							// {
							//     title: "Pay Groups",
							//     path: "/payroll-configuration/pay-groups",
							// },
						]}
					/>
				</div>

				<div className="flex items-center justify-start lg:justify-between flex-wrap lg:flex-nowrap">
					{/* <div className="flex items-center mt-5 mb-7 lg:mb-0 border-b-2">
						{navItems.map(({title, path}) => {
							const isActive = pathname?.includes(path)
							return ( 
								<div className={`tab lg:whitespace-nowrap text-xs md:text-sm ${isActive && "active"}`} key={path}>
									<Link to={path}>
										{title}
									</Link>
								</div>
							)
						})}
					</div> */}
					
					{/* <Maybe condition={isPayrollUser}>
						<FreeTrialInlineCountdown />
					</Maybe> */}
				</div>
				
				<section className='w-full pt-5'>
					{/* 
					<div className='pb-6 text-fade-667085 text-sm'>
						{activeRoute?.subtitle}.
					</div>
					*/}
					{children}
				</section>
			</Maybe>
		</EmployeeAdminLayout>
	)
}

export default GrossPayrollLayout